import React from "react";
import Drawer from "@mui/material/Drawer";
import styled from "styled-components";
import { logReportSchedulerEvents } from "../../../services/DashboardDesigner/eventActions";

const DrawerMainContainer = styled.div`
	width: ${props => `${props.width}`};
`;

const DrawerFooter = styled.div`
	width: ${props => `${props.width}`};
`;

export default ({
	title,
	subtitle,
	isOpen = false,
	position = "right",
	children,
	toggleDrawer,
	submitButtonText = "Submit",
	hasForm = false,
	formId,
	width = "30VW",
	isDisabled,
	isReportScheduler,
	id
}) => {
	const handleDrawerClose = e => {
		if (e.type == "keydown") {
			return;
		}
		if (isReportScheduler) {
			logReportSchedulerEvents.schedule_closed();
		}
		toggleDrawer(!isOpen);
	};

	return (
		<Drawer
			anchor={position}
			open={isOpen}
			onClose={handleDrawerClose}
			id={id}
			// MUI's default Drawer z-index (1200) sits well below this app's fixed top-nav
			// (z-index 10001) and side-nav (up to 15000), so without this the nav bar paints
			// over the drawer's own header/backdrop instead of the drawer opening on top of it.
			sx={{ zIndex: 100010 }}
		>
			<DrawerMainContainer
				width={width}
				className="custom-drawer drawer"
				role="presentation"
				onKeyDown={handleDrawerClose}
			>
				<div className="custom-drawer-header my-3 mb-4">
					<div>
						<p className="mb-0 tx-semi-bold header-title tx-size-16">{title}</p>
						{subtitle && <p className="mt-2 mb-0 tx-semi-bold tx-grey tx-size-14">{subtitle}</p>}
					</div>
					<button type="button" className="btn float-end close-button" title="Close">
						<span className="material-icons icon tx-slate-light-icon" onClick={handleDrawerClose}>
							highlight_off
						</span>
					</button>
				</div>
				<hr className="m-0" />
				<div className="custom-drawer-body">{children}</div>
				{hasForm && (
					<DrawerFooter width={width} className="custom-drawer-footer">
						<button
							form={formId}
							className={`${
								!isDisabled ? "btn btn-ge-primary" : "btn btn-ge-primary-disabled"
							} float-end my-2`}
							type="submit"
						>
							{submitButtonText}
						</button>
						<button className="btn btn-ge-secondary float-end m-2" onClick={handleDrawerClose}>
							Cancel
						</button>
					</DrawerFooter>
				)}
			</DrawerMainContainer>
		</Drawer>
	);
};
